'use client';
import { zodResolver } from '@hookform/resolvers/zod';
import axios from 'axios';
import clsx from 'clsx';
import BasicButton from 'core/BasicButton';
import BasicLink from 'core/BasicLink';
import { Controller, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import TextField from 'shared/sections/OfferBody/OfferForm/TextField';
import { z } from 'zod';

import cn from './style.module.sass';

const SignUpSchema = z.object({
    name: z
        .string()
        .min(1, { message: 'слишком короткое имя' })
        .max(100, { message: 'слишком длинное имя' }),
    mail: z
        .string()
        .email({ message: 'введите корректный email' })
        .max(100, { message: 'слишком длинный адрес' }),
    phone: z.string(),
    words: z.string(),
});

type SignUpSchemaType = z.infer<typeof SignUpSchema>;

export default function ContactsForm() {
    const methods = useForm<SignUpSchemaType>({
        resolver: zodResolver(SignUpSchema),
        defaultValues: { name: '', mail: '', phone: '', words: '' },
    });
    const {
        handleSubmit,
        register,
        control,
        reset,
        formState: { errors },
    } = methods;

    async function onSubmit(data: SignUpSchemaType) {
        try {
            const totalData = {
                fields: {
                    TITLE: data.name,
                    OPENED: 'Y',
                    CATEGORY_ID: 2,
                    ASSIGNED_BY_ID: 1290,
                    PROBABILITY: 0,
                    CURRENCY_ID: 'RUB',
                    OPPORTUNITY: 0,
                    BEGINDATA: new Date(),
                    DATA_CREATE: new Date(),
                    UF_CRM_58F5E45E004FF: document.cookie,
                    UF_CRM_1505909277: data.name,
                    UF_CRM_1505909288: data.phone,
                    UF_CRM_1505909324: data.mail,
                    UF_CRM_1674482952485: data.words,
                    UF_CRM_1505909447: 'страница "Контакты"',
                    UF_CRM_1505909470: window.location.href,
                },
            };
            await axios
                .post(
                    'https://cp.webpractik.ru/rest/1/58pkir8vmteeyte8/crm.deal.add.json',
                    totalData
                )
                .then(() => {
                    window?.ym(12895207, 'reachGoal', 'form');
                })
                .catch(e => {
                    console.log(e);
                    throw new Error('что-то пошло не так');
                });
            reset();
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <form onSubmit={event => void handleSubmit(onSubmit)(event)}>
            <div className={cn['contacts-form__field']}>
                <TextField
                    isError={errors.name}
                    className={cn['contacts-form__name']}
                    title="Ваше имя"
                    type="text"
                    {...register('name')}
                />
            </div>

            <div className={cn['contacts-form__field']}>
                <TextField
                    isError={errors.mail}
                    className={cn['contacts-form__email']}
                    title="E-mail"
                    type="email"
                    {...register('mail')}
                />

                <label htmlFor="phone" className={cn['contacts-form__containerPhone']}>
                    <span className={cn['contacts-form__phone']}>Телефон</span>
                    <Controller
                        control={control}
                        name="phone"
                        render={({ field: { onChange, value } }) => (
                            <InputMask
                                mask="9 (999) 999-9999"
                                type="tel"
                                value={value}
                                name="phone"
                                className={cn['contacts-container__input']}
                                onChange={onChange}
                            />
                        )}
                    />
                </label>
            </div>

            <label className={cn['contacts-form__label-container']}>
                <span className={cn['input__name-textarea']}>Расскажите о своем проекте</span>
                <textarea {...register('words')} className={cn['words-container__textarea']} />
            </label>

            <div className={cn['contacts-form__submit-container']}>
                <BasicButton
                    type="submit"
                    className={clsx(
                        cn['contacts-form__submit-button'],
                        cn['button button--color'],
                        cn['button--flat']
                    )}
                >
                    отправить
                </BasicButton>
                <div className={cn['contacts-form__submit-text']}>
                    Нажимая на&nbsp;кнопку &laquo;Отправить&raquo;, вы&nbsp;даете согласие на&nbsp;{' '}
                    <BasicLink href="/personal-data" target="_blank">
                        обработку персональных данных
                    </BasicLink>
                </div>
            </div>
        </form>
    );
}
